/**
 * Per-tenant GTM container + Tag Gateway measurement path.
 * Other tenants keep loading from googletagmanager.com.
 *
 * Container load and Google-tag collect (`server_container_url`) both use
 * lasertag.* so tracking is not bound to the product / tenant domain.
 * @see https://developers.google.com/tag-platform/tag-manager/gateway/setup-guide?setup=manual
 */
const GTM_GATEWAY_TENANTS: Record<string, { gtmId: string; path: string }> = {
  carbonify: { gtmId: 'GTM-NNGL797', path: '/gtm-nngl797' },
  carbonifyat: { gtmId: 'GTM-K254RC93', path: '/gtm-k254rc93' },
  smartcarb: { gtmId: 'GTM-PDX2FSSF', path: '/gtm-pdx2fssf' },
  fairnergy: { gtmId: 'GTM-KH25FVJX', path: '/gtm-kh25fvjx' },
};

const isTagGatewayEnabled = String(process.env.NEXT_PUBLIC_ENABLE_TAG_GATEWAY) === 'true';

const getGtmGatewayHost = (): string | undefined => {
  const configured = process.env.NEXT_PUBLIC_GTM_GATEWAY_HOST?.replace(/\/$/, '');
  if (configured) {
    return configured;
  }

  const apiUrl = process.env.NEXT_PUBLIC_API_URL;
  if (!apiUrl) {
    return undefined;
  }

  try {
    const mainDomain = new URL(apiUrl).hostname.replace(/^api\./, '');
    return `https://lasertag.${mainDomain}`;
  } catch {
    return undefined;
  }
};

export const getGtmGatewaySourceUrl = (tenant: string): string | undefined => {
  if (!isTagGatewayEnabled) {
    return undefined;
  }

  const host = getGtmGatewayHost();
  const config = GTM_GATEWAY_TENANTS[tenant];
  if (!host || !config) {
    return undefined;
  }

  return `${host}${config.path}/`;
};
